import BACKGROUND_IMAGES_LEFT_ARROWS_DARK_SVG from './left/arrows-dark.svg';
import BACKGROUND_IMAGES_LEFT_ARROWS_LIGHT_SVG from './left/arrows-light.svg';
import BACKGROUND_IMAGES_LEFT_HILLS_DARK_SVG from './left/hills-dark.svg';
import BACKGROUND_IMAGES_LEFT_HILLS_LIGHT_SVG from './left/hills-light.svg';
import BACKGROUND_IMAGES_LEFT_STARS_DARK_SVG from './left/stars-dark.svg';
import BACKGROUND_IMAGES_LEFT_STARS_LIGHT_SVG from './left/stars-light.svg';
import BACKGROUND_IMAGES_LEFT_SWIRLS_DARK_SVG from './left/swirls-dark.svg';
import BACKGROUND_IMAGES_LEFT_SWIRLS_LIGHT_SVG from './left/swirls-light.svg';
import BACKGROUND_IMAGES_RIGHT_ARROWS_DARK_SVG from './right/arrows-dark.svg';
import BACKGROUND_IMAGES_RIGHT_ARROWS_LIGHT_SVG from './right/arrows-light.svg';
import BACKGROUND_IMAGES_RIGHT_HILLS_DARK_SVG from './right/hills-dark.svg';
import BACKGROUND_IMAGES_RIGHT_HILLS_LIGHT_SVG from './right/hills-light.svg';
import BACKGROUND_IMAGES_RIGHT_STARS_DARK_SVG from './right/stars-dark.svg';
import BACKGROUND_IMAGES_RIGHT_STARS_LIGHT_SVG from './right/stars-light.svg';
import BACKGROUND_IMAGES_RIGHT_SWIRLS_DARK_SVG from './right/swirls-dark.svg';
import BACKGROUND_IMAGES_RIGHT_SWIRLS_LIGHT_SVG from './right/swirls-light.svg';

const BACKGROUND_IMAGES_HILLS = {
	'left-light': BACKGROUND_IMAGES_LEFT_HILLS_LIGHT_SVG,
	'right-light': BACKGROUND_IMAGES_RIGHT_HILLS_LIGHT_SVG,
	'left-dark': BACKGROUND_IMAGES_LEFT_HILLS_DARK_SVG,
	'right-dark': BACKGROUND_IMAGES_RIGHT_HILLS_DARK_SVG,
};

const BACKGROUND_IMAGES_STARS = {
	'left-light': BACKGROUND_IMAGES_LEFT_STARS_LIGHT_SVG,
	'right-light': BACKGROUND_IMAGES_RIGHT_STARS_LIGHT_SVG,
	'left-dark': BACKGROUND_IMAGES_LEFT_STARS_DARK_SVG,
	'right-dark': BACKGROUND_IMAGES_RIGHT_STARS_DARK_SVG,
};

const BACKGROUND_IMAGES_SWIRLS = {
	'left-light': BACKGROUND_IMAGES_LEFT_SWIRLS_LIGHT_SVG,
	'right-light': BACKGROUND_IMAGES_RIGHT_SWIRLS_LIGHT_SVG,
	'left-dark': BACKGROUND_IMAGES_LEFT_SWIRLS_DARK_SVG,
	'right-dark': BACKGROUND_IMAGES_RIGHT_SWIRLS_DARK_SVG,
};

const BACKGROUND_IMAGES_ARROWS = {
	'left-light': BACKGROUND_IMAGES_LEFT_ARROWS_LIGHT_SVG,
	'right-light': BACKGROUND_IMAGES_RIGHT_ARROWS_LIGHT_SVG,
	'left-dark': BACKGROUND_IMAGES_LEFT_ARROWS_DARK_SVG,
	'right-dark': BACKGROUND_IMAGES_RIGHT_ARROWS_DARK_SVG,
};

export const BACKGROUND_IMAGES_MAP = {
	hills: BACKGROUND_IMAGES_HILLS,
	stars: BACKGROUND_IMAGES_STARS,
	swirls: BACKGROUND_IMAGES_SWIRLS,
	arrows: BACKGROUND_IMAGES_ARROWS,
};
